import type { CSSProperties } from 'react';
import type { StickerItem } from '@reactvideoeditor/react-video-editor/types';
import { AspectlyQrCode } from '@/rve/aspectlyQrCode';
import {
  ASPECTLY_QR_DEFAULT_URL,
  parseAspectlyQrStickerContent,
} from '@/rve/aspectlyQrStickerContent';

const QR_BOX_STYLE: CSSProperties = {
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
};

function qrPixelSize(overlay: StickerItem): number {
  return Math.max(24, Math.round(Math.min(overlay.width, overlay.height) * 0.8));
}

/** RVE sticker template + timeline render (``react-qr-code``, same as legacy render-service). */
export function AspectlyQrStickerRveComponent({
  overlay,
}: {
  overlay: StickerItem;
}) {
  const parsed = parseAspectlyQrStickerContent(overlay.content);
  const url = parsed?.url ?? ASPECTLY_QR_DEFAULT_URL;
  const size = qrPixelSize(overlay);

  return (
    <div style={QR_BOX_STYLE}>
      <AspectlyQrCode value={url} size={size} />
    </div>
  );
}
